import type { V2PendingShopifyIntegrationCookie } from "@v2/hooks/useInstallShopify";

import * as React from "react";

import { toast } from "@replohq/lattice/components/toast/Toast";
import useInstallShopify from "@v2/hooks/useInstallShopify";
import { getErrorMessage } from "replo-utils/lib/errors";

interface UseShopifyIntegrationConnectProps {
  cookieValue: V2PendingShopifyIntegrationCookie;
}

export const useShopifyIntegrationConnect = ({
  cookieValue,
}: UseShopifyIntegrationConnectProps) => {
  const [isLoading, setLoading] = React.useState(false);

  const installShopify = useInstallShopify();

  const handleConnect = React.useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      setLoading(true);

      try {
        installShopify({
          cookie: cookieValue,
        });
      } catch (error) {
        setLoading(false);
        toast.error({
          title: "Connection failed",
          description: getErrorMessage(error, "Failed to connect Shopify"),
        });
      }
    },
    [cookieValue, installShopify],
  );

  return {
    isLoading,
    handleConnect,
  };
};
